import { useEffect } from "react";
import { useMap } from "react-leaflet";
import L from "leaflet";

const HardPolygon = ({ color = "yellow", coord }) => {
  const map = useMap();
  
  useEffect(() => {
    if (map && coord && coord.length > 0) {
      const polygon = L.polygon(coord, {
        color,
        weight: 4,
        opacity: 0.8,
      
        fillOpacity: 0,
      });

      polygon.addTo(map);

      // Fit map bounds to the polygon bounds if valid
      if (polygon.getBounds().isValid()) {
        map.fitBounds(polygon.getBounds());
      }

      // Cleanup on component unmount
      return () => {
        map.removeLayer(polygon);
      };
    }
  }, [map, color,coord ]);

  return null;
};

export default HardPolygon;